import React, { Fragment } from "react";
import { useParams, Link } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ServicesDropdown from "./ServicesDropdown";
import servicesData, { subTopicImages } from "./servicesData";
import { FaHandsHelping, FaChevronRight } from "react-icons/fa";
import UniformCard from "../../components/UniformCard/UniformCard";
import { Box } from "@mui/material";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const formatSlug = (text) => {
  if (!text) return "";
  return text
    .replace(/&/g, "And")
    .replace(/-/g, " ")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .split(" ")
    .map((word, i) =>
      i === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join("");
};

const ServiceCategoryPage = () => {
  const { slug } = useParams();

  // Find the service group (category) that matches the slug
  const categoryData = servicesData.find((s) => formatSlug(s.sTitle) === slug);

  if (!categoryData) {
    return (
      <Fragment>
        <PageTitle pageTitle="Category Not Found" pagesub={"Services"} />
        <section className="section-padding text-center">
          <div className="container">
            <h2>Oops! Service category not found.</h2>
            <Link to="/services" className="theme-btn">
              Back to Services
            </Link>
          </div>
        </section>
        <Scrollbar />
      </Fragment>
    );
  }

  // Extract sub-topics
  const subTopics = [
    categoryData.sub1,
    categoryData.sub2,
    categoryData.sub3,
    categoryData.sub4,
    categoryData.sub5,
  ].filter(Boolean);

  return (
    <Fragment>
      <PageTitle pageTitle={categoryData.sTitle} />

      <section
        className="service-category-section section-padding"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <div className="container">
          <div className="row g-4">
            {/* Main Content */}
            <div className="col col-lg-9 col-12">
              {/* Hero Card */}
              <div
                className="service-hero-card"
                style={{
                  background: "var(--primary-color)",
                  borderRadius: "15px",
                  padding: "60px 45px",
                  marginBottom: "40px",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <h1
                  style={{
                    color: "#fff",
                    fontSize: "2.8rem",
                    fontWeight: "800",
                    marginBottom: "25px",
                    position: "relative",
                    zIndex: 1,
                    lineHeight: "1.2",
                  }}
                >
                  {categoryData.sTitle}
                </h1>
                {categoryData.intro && (
                  <p
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontSize: "1.25rem",
                      lineHeight: "1.7",
                      marginBottom: 0,
                      position: "relative",
                      zIndex: 1,
                      maxWidth: "800px",
                    }}
                  >
                    {categoryData.intro}
                  </p>
                )}
              </div>

              {/* Overview Section */}
              {categoryData.description && (
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "20px",
                    padding: "45px",
                    marginBottom: "50px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                    borderLeft: "6px solid var(--primary-color)",
                  }}
                >
                  <h3
                    style={{
                      color: "var(--primary-color)",
                      fontSize: "1.8rem",
                      fontWeight: "700",
                      marginBottom: "25px",
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <span
                      style={{
                        width: "30px",
                        height: "4px",
                        background: "var(--primary-color)",
                        borderRadius: "2px",
                      }}
                    ></span>
                    Overview
                  </h3>
                  <div
                    style={{
                      color: "#4a5568",
                      fontSize: "1.15rem",
                      lineHeight: "1.8",
                    }}
                  >
                    {Array.isArray(categoryData.description) ? (
                      categoryData.description.map((para, i) => (
                        <p
                          key={i}
                          style={{
                            marginBottom:
                              i === categoryData.description.length - 1
                                ? 0
                                : "20px",
                          }}
                        >
                          {para}
                        </p>
                      ))
                    ) : (
                      <p style={{ marginBottom: 0 }}>
                        {categoryData.description}
                      </p>
                    )}
                  </div>
                </div>
              )}

              {/* Sub-topics Grid */}
              <div style={{ marginBottom: "60px" }}>
                <div style={{ textAlign: "center", marginBottom: "45px" }}>
                  <h2
                    style={{
                      color: "var(--primary-color)",
                      fontSize: "2.4rem",
                      fontWeight: "800",
                      marginBottom: "15px",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    Key Focus Areas
                  </h2>
                  <div
                    style={{
                      width: "60px",
                      height: "5px",
                      background:
                        "linear-gradient(to right, var(--primary-color), #2a52be)",
                      margin: "0 auto",
                      borderRadius: "10px",
                    }}
                  ></div>
                </div>

                <div className="row g-4">
                  {subTopics.map((sub, idx) => (
                    <div className="col-12 col-md-6" key={idx}>
                      <Link
                        to={`/services/${formatSlug(sub)}`}
                        onClick={ClickHandler}
                        style={{ textDecoration: "none" }}
                      >
                        <UniformCard
                          image={subTopicImages[sub]}
                          title={sub}
                          imageFit="contain"
                          aspectRatio="16/10"
                          imagePadding="20px"
                          centered={false}
                          sx={{
                            cursor: "pointer",
                            height: "100%",
                            "& .card-image-hover": {
                              transition:
                                "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                            },
                            "&:hover": {
                              transform: "translateY(-10px)",
                              borderColor: "var(--primary-color)",
                              boxShadow:
                                "0 20px 40px rgba(var(--primary-color-rgb), 0.15)",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              color: "var(--primary-color)",
                              fontWeight: 600,
                              fontSize: "0.95rem",
                              mt: 1,
                            }}
                          >
                            Learn More
                            <FaChevronRight
                              style={{ marginLeft: "8px", fontSize: "0.8rem" }}
                            />
                          </Box>
                        </UniformCard>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col col-lg-3 col-12">
              <div style={{ position: "sticky", top: "100px" }}>
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "20px",
                    padding: "30px",
                    marginBottom: "30px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                    border: "1px solid rgba(0,0,0,0.05)",
                  }}
                >
                  <ServicesDropdown
                    ClickHandler={ClickHandler}
                    ServicesData={servicesData}
                  />
                </div>

                <div
                  style={{
                    background: "var(--primary-color)",
                    borderRadius: "15px",
                    padding: "40px 30px",
                    textAlign: "center",
                    boxShadow: "0 15px 35px rgba(0,0,0,0.15)",
                  }}
                >
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      background: "rgba(255,255,255,0.1)",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 20px",
                    }}
                  >
                    <FaHandsHelping size={28} color="#fff" />
                  </div>
                  <h4
                    style={{
                      color: "#fff",
                      fontSize: "1.3rem",
                      marginBottom: "15px",
                    }}
                  >
                    Need Help?
                  </h4>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: "0.95rem",
                      marginBottom: "25px",
                    }}
                  >
                    Speak with our experts for professional guidance.
                  </p>
                  <Link
                    onClick={ClickHandler}
                    to="/contact"
                    style={{
                      display: "block",
                      background: "#fff",
                      color: "var(--primary-color)",
                      padding: "12px",
                      borderRadius: "50px",
                      fontWeight: "700",
                      textDecoration: "none",
                    }}
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Scrollbar />
    </Fragment>
  );
};

export default ServiceCategoryPage;
